import {FlaskConical} from 'lucide-react'
import { Link } from 'react-router-dom'

export type TabId = 'home' | 'calculators' | 'directory' | 'legal'

interface Tab {
  id: TabId
  label: string
  shortLabel: string
  path: string
}

const TABS: Tab[] = [
  { id: 'home', label: 'Home / Educational Pillars', shortLabel: 'Home', path: '/' },
  { id: 'calculators', label: 'Lab Calculator Suite', shortLabel: 'Calculators', path: '/calculators/molarity' },
  { id: 'directory', label: 'Biotech Directory', shortLabel: 'Directory', path: '/directory' },
  { id: 'legal', label: 'Regulatory & Legal', shortLabel: 'Legal', path: '/legal' },
]

interface HeaderProps {
  activeTab: TabId
}

function Header({ activeTab }: HeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-slate-900 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <FlaskConical className="h-7 w-7 text-emerald-500" aria-hidden="true" />
            <span className="text-xl font-extrabold text-white tracking-tight">
              BioSlick <span className="text-slate-400 font-semibold">实验计算站</span>
            </span>
            <span className="hidden sm:inline text-xs font-medium text-slate-400 border-l border-slate-700 pl-2 ml-1">
              Lab Calculator Suite
            </span>
          </div>
        </div>

        <nav
          role="tablist"
          aria-label="Primary site sections"
          className="flex flex-wrap gap-1 pb-3 -mt-1"
        >
          {TABS.map(tab => {
            const isActive = activeTab === tab.id
            return (
              <Link
                key={tab.id}
                to={tab.path}
                role="tab"
                id={`tab-${tab.id}`}
                aria-selected={isActive}
                aria-controls={`panel-${tab.id}`}
                className={
                  isActive
                    ? 'px-3 py-2 rounded-md text-sm font-semibold bg-emerald-600 text-white'
                    : 'px-3 py-2 rounded-md text-sm font-semibold text-slate-300 hover:bg-slate-800 hover:text-white transition-colors'
                }
              >
                <span className="sm:hidden">{tab.shortLabel}</span>
                <span className="hidden sm:inline">{tab.label}</span>
              </Link>
            )
          })}
        </nav>
      </div>
    </header>
  )
}

export default Header
